import { render, staticRenderFns } from "./NewCourseStep2.vue?vue&type=template&id=3d8d80cc"
import script from "./NewCourseStep2.vue?vue&type=script&lang=js"
export * from "./NewCourseStep2.vue?vue&type=script&lang=js"
import style0 from "./NewCourseStep2.vue?vue&type=style&index=0&id=3d8d80cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports